import React from 'react';
import AzureSVG from '../../assets/azure_logo.svg';

const AzureSquareLogo = (props) => (
  <img alt="Azure" src={AzureSVG} style={props} />
);

export default AzureSquareLogo;
